import { MapPersistedEntityColumns } from "@mapmycustomers/shared/types/entity";

import { PinnedListsChange } from "./getChangedPinnedLists";
import toMapConfigurationPatch from "./toMapConfigurationPatch";

// The `metaData` an org or team save sends: those PUTs replace all of `metaData`, so every key
// goes back as held (same references) with only the changed lists, flat copies and flags replaced
const applyPinnedListsChange = <
  T extends { mapConfiguration?: Partial<MapPersistedEntityColumns> },
>(
  metaData: T | undefined,
  change: PinnedListsChange
): T => {
  const { fields: changedFields, ...changedFlatLists } = toMapConfigurationPatch(change);
  const mapConfiguration = metaData?.mapConfiguration;

  // The spread keeps every key of the given `metaData`, so the result is that `T` with its
  // `mapConfiguration` replaced. TypeScript cannot see that for a generic `T`, and a `fields` that
  // holds only the changed lists is narrower than the stored shape, which lists every key.
  return {
    ...metaData,
    mapConfiguration: {
      ...mapConfiguration,
      ...changedFlatLists,
      fields: { ...mapConfiguration?.fields, ...changedFields },
    },
  } as T;
};

export default applyPinnedListsChange;
